var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMac = function SvgMac(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 25",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6719 22.4875C17.4743 23.6484 16.1666 23.4651 14.9079 22.9152C13.5759 22.353 12.3538 22.3286 10.9484 22.9152C9.18864 23.6729 8.25986 23.4529 7.20889 22.4875C1.24519 16.3405 2.12508 6.97941 8.89534 6.63723C10.5451 6.72277 11.6939 7.54156 12.6593 7.61488C14.1013 7.32159 15.4823 6.47836 17.0221 6.58835C18.8674 6.735 20.2606 7.46824 21.1771 8.78807C17.3643 11.0733 18.2686 16.096 21.7637 17.5014C21.0671 19.3345 20.1628 21.1554 18.6597 22.4997L18.6719 22.4875ZM12.5371 6.56391C12.3538 3.83869 14.5657 1.59009 17.1076 1.37012C17.462 4.52305 14.248 6.86942 12.5371 6.56391Z",
    fill: "white"
  })));
};
export default SvgMac;